import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import { TransportOption } from "../../../models/financing-request/transport-option/TransportOption";
import SchoolCarrierTransportOption from "../../../models/financing-request/transport-option/SchoolCarrierTransportOption";
import { nameof } from "../../../utilities/utilities";
import { SchoolCarrier } from "../../../models/financing-request/SchoolCarrier";
import TrSelect from "../../shared/controls/TrSelect";
import { VehicleType } from "../../../models/vehicle-type/VehicleType";
import TrSelectData from "../../../models/shared/TrSelectData";
import SelectItem from "../../../models/shared/SelectItem";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import TrackerName from "../../../models/financing-request/student-data/FinancingRequestStudentDataTrackerName";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";

interface Props {
  index: number;
  vehicleTypeItems: SelectItem<VehicleType>[];
  transportOption: TransportOption;
  schoolCarriers: SchoolCarrier[];
  validationResult: ValidationResult;
  onChange?: (e: any) => void;
  onSelectChange?: (e: any) => void;
}

interface SelectVehicleType {
  vehicleType: VehicleType;
  text: string;
}

export default function SchoolCarrierTransportItem({
  index,
  vehicleTypeItems,
  transportOption,
  schoolCarriers,
  validationResult,
  onChange,
  onSelectChange
}: Props) {
  let schoolCarrierTransportOption = transportOption as SchoolCarrierTransportOption;

  useEffect(() => {
    schoolCarrierTransportOption = transportOption as SchoolCarrierTransportOption;
  }, [transportOption]);

  function getVehicleType() {
    let types = new Array<VehicleType>();

    schoolCarriers.forEach(schoolCarrier => {
      if (
        schoolCarrier.vehicleType &&
        !types.includes(schoolCarrier.vehicleType)
      ) {
        types.push(schoolCarrier.vehicleType);
      }
    });

    let typesData: SelectVehicleType[] = new Array<SelectVehicleType>();
    types.forEach(type => {
      const vType = vehicleTypeItems.find(vti => vti.value == type);
      if (vType) {
        typesData.push({
          vehicleType: type,
          text: vType.text
        });
      }
    });

    const selectTypeData: TrSelectData<SelectVehicleType> = {
      valueProp: "vehicleType",
      textProp: "text",
      data: typesData
    };

    return selectTypeData;
  }

  function getRegistrationPlateItems() {
    let selectedSchoolCarriers = new Array<SchoolCarrier>();

    schoolCarriers.forEach(schoolCarrier => {
      if (
        schoolCarrier.vehicleType &&
        schoolCarrier.vehicleType === schoolCarrierTransportOption.vehicleType
      ) {
        selectedSchoolCarriers.push(schoolCarrier);
      }
    });

    const selectRegistrationPlateData: TrSelectData<SchoolCarrier> = {
      valueProp: "registrationPlate",
      textProp: "registrationPlate",
      data: selectedSchoolCarriers
    };

    return selectRegistrationPlateData;
  }

  return (
    <>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <TrSelect
          required
          name={nameof<typeof schoolCarrierTransportOption>("vehicleType")}
          id="vehicleTypeSelect"
          className="selectFormControl"
          label="Vrsta vozila"
          value={schoolCarrierTransportOption.vehicleType}
          onChange={onSelectChange}
          selectData={getVehicleType()}
          error={
            !validationResult.isArrayPropertyWithParrentValid(
              TrackerName.StudentsData,
              index.toString(),
              nameof<FinancingRequestStudentData>("transportOption"),
              nameof<SchoolCarrierTransportOption>("vehicleType")
            )
          }
        ></TrSelect>
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <TrSelect
          required
          disabled={schoolCarrierTransportOption.vehicleType ? false : true}
          name={nameof<typeof schoolCarrierTransportOption>(
            "registrationPlate"
          )}
          id="registrationPlate"
          className="selectFormControl"
          label="Registracijske oznake"
          value={schoolCarrierTransportOption.registrationPlate}
          onChange={onSelectChange}
          selectData={getRegistrationPlateItems()}
          error={
            !validationResult.isArrayPropertyWithParrentValid(
              TrackerName.StudentsData,
              index.toString(),
              nameof<FinancingRequestStudentData>("transportOption"),
              nameof<typeof schoolCarrierTransportOption>("registrationPlate")
            )
          }
        ></TrSelect>
      </Grid>
    </>
  );
}
